import { render, staticRenderFns } from "./guide-in-card-component.vue?vue&type=template&id=65bd85df"
import script from "./guide-in-card-component.vue?vue&type=script&lang=js"
export * from "./guide-in-card-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports